import * as ActionTypes from './brandActionTypes';

const initialState = {
  list: [],
  isLoading: false,
  error: null,
};

export const brandReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PUBLIC_BRANDS:
      return { ...state, isLoading: true, error: null };
    case ActionTypes.GET_PUBLIC_BRANDS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case ActionTypes.GET_PUBLIC_BRANDS_SUCCESS: {
      const raw = action.payload?.data;
      let list = [];
      if (Array.isArray(raw)) {
        list = raw;
      } else if (raw && Array.isArray(raw.rows)) {
        list = raw.rows;
      }
      return {
        ...state,
        isLoading: false,
        list,
      };
    }
    default:
      return state;
  }
};
